import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgEvolutionCompute = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-evolution-compute';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.778 4.072a726 726 0 0 0-4.29 2.488l-.088.06.179.3.179.3-.369.02-.369.02-.01 4.945c-.008 3.926 0 4.953.04 4.985.027.023 1.913 1.116 4.19 2.43 2.277 1.313 4.196 2.422 4.264 2.463l.123.076.177-.319c.097-.175.185-.319.196-.319s.099.144.196.319l.177.319.123-.076c.068-.041 1.987-1.15 4.264-2.463a546 546 0 0 0 4.19-2.43c.04-.032.048-1.103.04-5.205l-.01-5.164-4.48-2.589A679 679 0 0 0 12 1.643c-.011 0-1.911 1.093-4.222 2.429m7.945 1.446 3.737 2.157v8.654l-2.32 1.34-3.351 1.934-1.03.594.01-1.384.011-1.384 1.981-1.144c1.09-.63 2.049-1.185 2.131-1.234l.149-.089-.011-2.904-.01-2.904-2.46-1.422c-1.353-.783-2.49-1.431-2.526-1.441-.038-.01-.948.492-2.148 1.185a110 110 0 0 1-2.11 1.204c-.052 0-2.49-1.419-2.471-1.438.01-.01 1.516-.886 3.347-1.946s3.329-1.93 3.331-1.932 1.685.967 3.74 2.154M13.81 9.032l1.711.987-.011 2.053-.01 2.054-1.34.776c-.737.426-1.353.776-1.37.777-.017 0-.03-.923-.03-2.052v-2.053l-1.72-.992c-.946-.546-1.72-1.004-1.72-1.019 0-.055 2.662-1.563 2.72-1.541.033.013.83.467 1.77 1.01m-7.93.302 1.14.661.011 2.512.011 2.513 2.084 1.2c1.146.66 2.091 1.218 2.099 1.24s.011.645.006 1.383l-.011 1.342-3.34-1.928-3.34-1.928-.01-3.885-.01-3.886.11.058c.06.032.623.355 1.25.718m4.035 2.326 1.322.76.001 1.63c.001.897-.008 1.63-.02 1.63s-.624-.347-1.36-.77l-1.337-.77v-1.633c-.001-.969.014-1.628.036-1.62.02.007.631.355 1.358.773"
    })
  }));
});
export default SvgEvolutionCompute;